import { LOCALES } from 'i18n/locales';

export const platformNoticesPageIntl = {
    [LOCALES.ENGLISH]: {
        'platformNoticesPage.title': 'Upcoming downtime',
        'platformNoticesPage.lastUpdated': 'Last updated: {lastUpdated}',
        'platformNoticesPage.table.header.start': 'Start date',
        'platformNoticesPage.table.header.end': 'End date (estimated)',
        'platformNoticesPage.table.header.event': 'Event',
        'platformNoticesPage.table.header.status': 'Status'
    },
    [LOCALES.WELSH]: {
        'platformNoticesPage.title': '[Upcoming downtime]',
        'platformNoticesPage.lastUpdated': '[Last updated: {lastUpdated}]',
        'platformNoticesPage.table.header.start': '[Start date]',
        'platformNoticesPage.table.header.end': '[End date (estimated)]',
        'platformNoticesPage.table.header.event': '[Event]',
        'platformNoticesPage.table.header.status': '[Status]'
    }
};
